module.exports = __webpack_public_path__ + "static/capterra-3050a249010c1af3a0efc467bf66e3ce.svg";